import { PersonRequest } from "@plinknz/tah-website-elements";
import { bankConfig } from "./config-generics/bank-details";
import { overviewConfig } from "./config-generics/overview";
import { personalDetailsConfig } from "./config-generics/personal-details";
import { schoolConfig } from "./config-generics/school";
import { signatureConfig } from "./config-generics/signature";
import { PageConfig } from "../../components/content-blocks/forms/customer-form-types";
import { UserData } from "../reducers/user";

export const createSurveyConfig = (member: PersonRequest, user?: UserData) => {
    const personalConfig = personalDetailsConfig({
        member,
        children: user.onSameEmail,
    });

    const schoolDetailsConfig = schoolConfig();
    const overviewDetailsConfig = overviewConfig({
        heading: "Tahua Tuari Pia | Primary School Grants",
        content: [
            {
                heading: "Overview",
                lines: [
                    `Supports tamariki in Years 0–8 with school-related costs. It is for
           registered Ngāti Kuia whānau with primary-aged children.`,
                ],
            },
            {
                heading: "Eligibility",
                lines: [
                    "To apply for this grant, you must:",
                    [
                        "Be a registered member of Ngāti Kuia",
                        "Provide proof of bank account (deposit form or electronic statement).",
                        "Complete this form",
                    ],
                ],
            },
            {
                heading: "Key Dates & Deadlines",
                lines: [
                    [
                        "Applications Open: 1 December.",
                        "Applications Close: 31 December.",
                        `Payment will be made before school starting, directly to the bank
             account provided.`,
                        "Late or incomplete applications may not be accepted.",
                        "Due to high application volumes, please allow time for your application to be processed.",
                    ],
                ],
            },
            {
                heading: "Funding Available",
                lines: ["$75 per child per year."],
            },
            {
                heading: "Documents You'll Need",
                lines: [
                    [
                        "Bank account details (deposit form or electronic statement).",
                    ],
                ],
            },
        ],
    });

    const pages: PageConfig[] = [
        ...overviewDetailsConfig,
        ...personalConfig,
        ...bankConfig,
        ...schoolDetailsConfig,
        ...signatureConfig,
    ];

    return { pages };
};
